import { tickerItems } from "@/mocks/site";

export default function BreakingTicker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <section aria-label="快讯播报" className="border-b border-background-200 bg-foreground-950">
      <div className="mx-auto flex max-w-content items-center gap-3 px-4 md:gap-5 md:px-6">
        <span className="flex flex-none items-center gap-1.5 bg-primary-500 px-2.5 py-3 text-xs font-medium text-background-50 md:px-3.5">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-radio-line"></i>
          </span>
          快讯
        </span>
        <div className="relative flex-1 overflow-hidden py-3">
          <div className="ticker-track flex w-max items-center gap-8 md:gap-14">
            {loopItems.map((item, index) => (
              <span
                key={`ticker-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-background-200 md:text-sm"
              >
                <span className="rounded-md bg-secondary-700 px-2 py-0.5 text-[11px] text-background-100">
                  {item.tag}
                </span>
                {item.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}